/**
 * **Recon(-visible)** (Core p.273, 6-round cap, 4 CZs — one secretly the True CZ) —
 * PC win iff PCs `controlOf` the flagged True CZ (`SitrepZone.hidden`) at the end of
 * round 6, else enemy win. Reuses `controlOf` verbatim, no new occupancy logic.
 * **Concealment is not implemented here** — this predicate simply READS the `hidden`
 * flag GM-side; nothing here filters it out of a player-visible projection.
 */
import type { EncounterState, SitrepConfig } from "@lancer-vtt/domain";
import { controlOf } from "../zones";
import type { SitrepStatus } from "../status";
import { roundLimitReached, roundsRemainingFor } from "../roundBoundary";

export function reconStatus(state: EncounterState, sitrep: SitrepConfig): SitrepStatus {
  const trueCz = sitrep.zones.find((z) => z.hidden);
  const roundsRemaining = roundsRemainingFor(state, sitrep.roundLimit);
  if (!roundLimitReached(state, sitrep.roundLimit)) {
    return { phase: "active", roundsRemaining };
  }
  const controller = trueCz ? controlOf(state, trueCz) : null;
  return { phase: "decided", winner: controller === "pc" ? "pc" : "npc" };
}
